import React, { useState, useEffect } from 'react';
import _ from 'lodash';

const TYPE_EVENT_LISTENER = {
  FOCUS: 'focus',
  BLUR: 'blur',
  VISIBILITY_CHANGE: 'visibilitychange',
};

export default function useIsWindowFocused() {
  const [windowIsActive, setWindowIsActive] = useState(true);

  const handleActivity = React.useCallback(
    _.debounce(
      (e) => {
        if (e?.type === TYPE_EVENT_LISTENER.FOCUS) {
          return setWindowIsActive(true);
        }
        if (e?.type === TYPE_EVENT_LISTENER.BLUR) {
          return setWindowIsActive(false);
        }
        if (e?.type === TYPE_EVENT_LISTENER.VISIBILITY_CHANGE) {
          if (document.hidden) {
            return setWindowIsActive(false);
          } else {
            return setWindowIsActive(true);
          }
        }
      },
      100,
      { leading: false },
    ),
    [],
  );

  useEffect(() => {
    [TYPE_EVENT_LISTENER.VISIBILITY_CHANGE].map((type) => {
      document.addEventListener(type, handleActivity);
    });

    [TYPE_EVENT_LISTENER.BLUR, TYPE_EVENT_LISTENER.FOCUS].map((type) => {
      window.addEventListener(type, handleActivity);
    });

    return () => {
      [TYPE_EVENT_LISTENER.VISIBILITY_CHANGE].map((type) => {
        document.removeEventListener(type, handleActivity);
      });

      [TYPE_EVENT_LISTENER.BLUR, TYPE_EVENT_LISTENER.FOCUS].map((type) => {
        window.removeEventListener(type, handleActivity);
      });
    };
  }, []);

  return windowIsActive;
}
